import { DataTableOnlySelectedViewMode } from "@/types/dataTableSettings";
import { create } from "zustand";

interface QueryTableViewState {
  modesByTable: Record<string, DataTableOnlySelectedViewMode>;
  setMode: (tableName: string, mode: DataTableOnlySelectedViewMode) => void;
}

export const useQueryTableStore = create<QueryTableViewState>((set) => ({
  modesByTable: {},
  setMode: (tableName, mode) =>
    set((state) => ({
      modesByTable: {
        ...state.modesByTable,
        [tableName]: mode,
      },
    })),
}));
